import { PageHeader } from "@ant-design/pro-components";
import { Button, Col, Divider, Flex, InputNumber, Row, Space, Spin, Typography } from "antd";
import { observer } from 'mobx-react';
import React from "react";
import { useStore } from "../../stores/root-store";
import TagsEditor from "../common/filters/tags-editor";
import NumberInKimWithTheme from "../common/number-in-kim-with-theme";
import TaskImportCloneCard from "./task-import-clone-card";
import Subjects from "../../models/subjects";
// import '../common/page-header.css';

const { Text } = Typography;

const MathegeImport: React.FC<{}> = () => {

    const { mathegeImport } = useStore();

    const tagsStore = { data: mathegeImport.tags };
    const numberInKimWithTheme = { numberWithTheme: mathegeImport.numberInKimWithTheme };

    const handleClickSave = () => {
        mathegeImport.import();
    }
    const handleOnChangeTaskId = (value: number | null) => {
        mathegeImport.changeImportTask(value);
    }

    const spinBlock = <Flex align='center' vertical>
        <Spin size="large" tip="Не закрывайте вкладку до окончания загрузки..."><div style={{ padding: "100px" }} /></Spin>
    </Flex>;

    return (
        <div className="content">
            <PageHeader title="Импорт задач из открытого банка" className="site-page-header" />
            {mathegeImport.loading ? spinBlock :
                <Row gutter={8}>
                    <Col span={8}>
                        <NumberInKimWithTheme {...numberInKimWithTheme} />
                        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                            <TagsEditor {...tagsStore} />
                            <InputNumber
                                placeholder="номер задачи в банке"
                                min={1}
                                className="filter__item"
                                onChange={handleOnChangeTaskId}
                                value={mathegeImport.importedTask} />
                            <Button key="save" type="primary" onClick={handleClickSave}>Загрузить</Button>
                        </Space>
                    </Col>
                </Row>
            }
            {mathegeImport.task &&
                <Flex wrap="wrap" gap="middle" align="start">
                    <Divider orientation="left">Задача</Divider>
                    <TaskImportCloneCard task={mathegeImport.task} subject={Subjects.MATH} />
                </Flex>}
            {mathegeImport.task && mathegeImport.clones &&
                <Flex wrap="wrap" gap="middle" align="start">
                    <Divider orientation="left">Клоны</Divider>
                    {mathegeImport.clones?.length === 0 && <Text>Нет клонов</Text>}
                    {mathegeImport.clones.map(t => <TaskImportCloneCard key={t.data.id} task={t} subject={Subjects.MATH} />)}
                </Flex>}
        </div>
    );
};


export default observer(MathegeImport);